module.exports = __webpack_public_path__ + "img/header-ua.e00310e7.jpg";